"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidManifestSchemaVersionError = void 0;
class InvalidManifestSchemaVersionError extends Error {
    constructor(version) {
        super(`Invalid manifest schema version ${version}`);
        this.code = 422;
    }
}
exports.InvalidManifestSchemaVersionError = InvalidManifestSchemaVersionError;
//# sourceMappingURL=errors.js.map